/** Parses "Name — meta" / "Name | meta" lines for strip-style ops blocks. */
export function parseLabeledLines(raw: string): { label: string; meta: string }[] {
  return raw
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const parts = line.split(/\s+[—–|]\s+/);
      if (parts.length >= 2) {
        return { label: parts[0]!.trim(), meta: parts.slice(1).join(' — ').trim() };
      }
      return { label: line, meta: '' };
    });
}

export type RouteStopRow = {
  day: string;
  place: string;
  /** Maps search / explicit https URL for the stop. */
  href?: string;
};

function safeHttpsHref(raw: string | undefined): string | undefined {
  if (!raw?.trim()) return undefined;
  try {
    const url = new URL(raw.trim());
    return url.protocol === 'https:' ? url.toString() : undefined;
  } catch {
    return undefined;
  }
}

/** OpenStreetMap search for a place name (truck stop → map). */
export function mapsSearchHrefForPlace(place: string): string | undefined {
  const trimmed = place.trim();
  if (!trimmed) return undefined;
  return `https://www.openstreetmap.org/search?query=${encodeURIComponent(trimmed)}`;
}

/**
 * Wochenroute lines: `Di — Viktualienmarkt Süd` or
 * `Di — Viktualienmarkt Süd — https://…` (optional explicit maps URL).
 */
export function parseRouteStops(raw: string): RouteStopRow[] {
  return raw
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const parts = line
        .split(/\s+[—–|]\s+/)
        .map((part) => part.trim())
        .filter(Boolean);
      const day = parts[0] ?? line;
      const place = parts[1] ?? '';
      const explicitHref = safeHttpsHref(parts[2]);
      const href = explicitHref ?? mapsSearchHrefForPlace(place);
      return { day, place, href };
    });
}
